import { logoutSilent } from 'rde-view-common/middleware/auth';
import Vue from 'vue';

/**
 * 共通エラーハンドリング
 */
export default ({ app }) => {
  const defaultErrorHandler = Vue.config.errorHandler;
  Vue.config.errorHandler = (err, vm, info) => {
    if (err.isAxiosError !== true) {
      // Axiosエラーの場合はaxios.js#onErrorで処理するため、ここでは処理しない。
      try {
        defaultErrorHandler(err, vm, info);
      } catch (e) {
        console.log(err);
        logoutSilent();
        vm.$root.error(err);
      }
    }
  };
};
